// Auxilary : Generic container that propagates all parent's props 

const aux = (props) => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/hoc/_Aux.js